<template>
  <vs-popup class="manage-partner-agreement-templates" id="popup" title="MANAGE PARTNER AGREEMENT TEMPLATES"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">

          <div class="vx-row">
            <div class="vx-col w-1/3">Name</div>
            <div class="vx-col w-1/3">Duration</div>
            <div class="vx-col w-1/6">Percente (%)</div>
            <div class="vx-col w-1/6"></div>
          </div>
          <div class="vx-row mb-2" v-for="(template, template_index) in templates" :key="template_index">
            <div class="vx-col w-full">
              <div class="vx-row">
                <div class="vx-col w-1/3">
                  <ValidationProvider :vid="`${template_index}_name`" :name="`${template_index}_name`" rules="required"
                    v-slot="{ errors }">
                    <vs-input v-model="template.name" :name="`${template_index}_name`" class="w-full required" label=""
                      :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                  </ValidationProvider>
                </div>
                <div class="vx-col w-1/3">
                  <div class="vx-row">
                    <div class="vx-col w-1/3">
                      <ValidationProvider :vid="`${template_index}_duration`" :name="`${template_index}_duration`"
                        rules="required" v-slot="{ errors }">
                        <vs-input v-model="template.duration_amount" :name="`${template_index}_duration`"
                          class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                          val-icon-danger="icon-x" val-icon-pack="feather" />
                      </ValidationProvider>
                    </div>
                    <div class="vx-col w-2/3">
                      <ValidationProvider :vid="`${template_index}_duration_type`"
                        :name="`${template_index}_duration_type`" rules="required" v-slot="{ errors }">
                        <v-select :clearable="false" placeholder="" v-model="template.duration_type"
                          :reduce="option => option" :options="['Year', 'Month', 'Day']"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="vx-col w-1/6">
                  <ValidationProvider :vid="`${template_index}_percent`" :name="`${template_index}_percent`"
                    rules="required" v-slot="{ errors }">
                    <vs-input v-model="template.percent" :name="`${template_index}_percent`" class="w-full required"
                      label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                      val-icon-pack="feather" />
                  </ValidationProvider>
                </div>
                <div class="vx-col w-1/6">
                  <vs-button size="small" icon-pack="feather" icon="icon-trash-2" color="danger" class="float-left mt-2"
                    @click.stop="onClickDeleteTemplate(template_index)"></vs-button>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button size="small" icon-pack="feather" icon="icon-plus" class="float-left"
                @click.stop="onClickAddTemplate">
                Add new template
              </vs-button>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          </div>

          <!-- <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="percent" name="percent" rules="required" v-slot="{ errors }">
                <small class="label">Commission Percentage (%)</small>
                <vs-input v-model="createStaffForm.percent" name="percent" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="start_date" name="start_date" rules="required" v-slot="{ errors }">
                <small class="label">Agreement Start Date </small>
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="hidden" v-model="createStaffForm.start_date"
                  placeholder="Choose Date" />
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full" v-model="createStaffForm.start_date"
                  placeholder="Choose Date" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="end_date" name="end_date" rules="required" v-slot="{ errors }">
                <small class="label">Agreement End Date</small>
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="hidden" v-model="createStaffForm.end_date"
                  placeholder="Choose Date" />
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full" v-model="createStaffForm.end_date"
                  placeholder="Choose Date" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div> -->
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ChannelPartnerRepository = RepositoryFactory.get('channel_partner');
const CurrencyRepository = RepositoryFactory.get('currency');
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'
const CountryCodeRepository = RepositoryFactory.get('countryCode');
const UserRepository = RepositoryFactory.get('user');
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

function initialState() {
  return {
    open: false,
    templates: [],
    createStaffForm: {
      date_introduced: '',
      start_date: '',
      end_date: '',
      percent: ''
    },
    currencyList: {},
    countryCodes: [],
    account_handlers: [],
    tenant_id: null,
    customer_id: null,
  }
}

export default {
  name: 'CreateAgreementTemplatePopUp',
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
    flatPickr,
  },

  methods: {
    async openPopup(partner_id) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.partner_id = partner_id
        await this.fetchAllTemplates()
        this.open = true;
      } catch (error) {
        console.log("error", error)
      }
    },
    async fetchAllTemplates() {
      try {
        const { data } = await ChannelPartnerRepository.getListOfAgreementTemplates(this.partner_id, 1, 150)
        this.templates = data.data
      } catch (error) {

      }
    },
    onClickAddTemplate() {
      this.templates.push({ order: this.templates.length + 1, name: '', duration_type: 'Year', duration_amount: 1, percent: 0 })
    },
    onClickDeleteTemplate(index) {
      this.templates.splice(index, 1)
    },

    async onClickCreateStaffUser() {
      const vue = this;
      this.$vs.loading()
      try {
        const payload = this.templates.map((x, index) => {
          let new_obj = {}
          if (x.id) {
            new_obj.id = x.id
          }
          new_obj.name = x.name
          new_obj.duration_amount = Number(x.duration_amount).toFixed(0)
          new_obj.duration_type = x.duration_type
          new_obj.percent = Number(x.percent).toFixed(2)
          new_obj.order = index + 1
          return new_obj
        })
        console.log(payload);
        await ChannelPartnerRepository.createAgreementTemplate(this.partner_id, { agreement_templates: payload })
        await this.$emit('refreshData')
        this.open = false;
      } catch (e) {
        console.log(e.message);
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchCountryList() {
      const { data } = await CurrencyRepository.getCurrencyList()
      this.currencyList = data.data
    },
    async loadCountryCodes() {
      const { data } = await CountryCodeRepository.get()
      this.countryCodes = data.data
    },
    async fetchUsers() {
      const { data } = (await UserRepository.get(1, '', 150, '')).data
      this.account_handlers = data
    },
    onClickReset() {
      this.createStaffForm = {}
    }
  },
}
</script>

<style scoped>
.manage-partner-agreement-templates>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 50% !important;
}
</style>
